/**
 * External dependencies
 */
import { useEffect } from '@wordpress/element';

export function useCheckoutFail(checkoutProps) {
	const { eventRegistration, emitResponse } = checkoutProps;
	const { onCheckoutFail } = eventRegistration;

	useEffect(() => {
		const unsubscribe = onCheckoutFail(({ processingResponse }) => {
			const { paymentDetails, paymentStatus } = processingResponse;

			if (paymentStatus === 'failure') {
				return {
					type: emitResponse.responseTypes.ERROR,
					message: paymentDetails?.messages,
					messageContext: emitResponse.noticeContexts.PAYMENTS,
					retry: true,
				};
			}

			return true;
		});

		return () => {
			unsubscribe();
		};
	}, [
		emitResponse.responseTypes.ERROR,
		emitResponse.responseTypes.SUCCESS,
		emitResponse.noticeContexts.PAYMENTS,
		onCheckoutFail,
	]);
}
